<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Have some Cupcake Fun!</h1>
<p class="INTRO1">When I started my cake-making company 10 years ago, every order was all about having fun with different sizes of cake and icing in order to make the celebration in question memorable. Over the following years, customers have continued to challenge my team in their desire to see their varied hobbies and interests re-created in sugar and popped on top of a cake or cupcake. So this book brings lots of those simple, interesting ideas together to create delicious cupcakes for every occasion that really will make both kids and adults smile. These little cakes make great party centrepieces or gifts to show how much you care, or simply an entertaining family treat. The cake bases and frostings can be mixed and matched and used for any project you choose to decorate them with, or eat them just as they are for an everyday bite.</p>
<p class="INTRO1S">This book has been devised for those new to making cupcakes as well as those who are looking to expand their skills, whether with new flavours, designs or decorating techniques, and as a helpful guide each project has a skill rating indicated by one, <img alt="" height="17" src="images/Cupcake_Illustration_fmt.gif" width="15"/> two <img alt="" height="17" src="images/17131.gif" width="32"/> or three <img alt="" height="17" src="images/17144.gif" width="49"/> cupcake symbols.</p>
<p class="INTRO1S">I hope you enjoy learning some new recipes to bake and experimenting with tasty toppings to create, and don’t forget to sample them along the way – cook’s perks!</p>
<p class="INTRO1S">Have fun!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?67a40852